import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=fab32940&"
import script from "./environment.vue?vue&type=script&lang=js&"
export * from "./environment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports